<template>
  <div>
    <meta name="description"
      content="Découvrez les meilleures pizzas artisanales à Grenoble chez Mia. Livraison rapide et service de qualité. Pizzeria grenoble, pizza grenoble, restaurant italien grenoble" />
    <meta name="keywords"
      content="pizzeria grenoble, pizza grenoble, restaurant italien grenoble, livraison pizza grenoble, pizza à emporter grenoble, pizza artisanale grenoble, pizza maison grenoble, pizza italienne grenoble" />
    <main role="main">
      <!-- Spinner Start -->
      <div v-if="loading" id="spinner"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">
          <span class="sr-only">Chargement...</span>
        </div>
      </div>
      <!-- Spinner End -->

      <!-- Hero Section -->
      <div class="container-xxl position-relative p-0">
        <meta property="og:title" content="Mia - Les Meilleures Pizzas Artisanales à Grenoble" />
        <meta property="og:description"
          content="Découvrez les meilleures pizzas artisanales à Grenoble chez Mia. Livraison rapide et service de qualité. Pizzeria grenoble, pizza grenoble, restaurant italien grenoble" />
        <meta property="og:image" content="https://www.mia-restaurant.fr/img/pizzaRounded.png" />
        <meta property="og:url" content="https://www.mia-restaurant.fr" />
        <meta property="og:type" content="website" />
        <AppHeader />

        <div id="home" class="container-xxl py-5 bg-dark hero-header mb-5 position-relative" itemscope
          itemtype="http://schema.org/Restaurant">
          <!-- Image LCP invisible mais détectée par Lighthouse -->

          <div class="container my-5 py-5">
            <div class="row g-5">
              <div v-if="this.$store.state.accueil" class="col-lg-6 align-items-center text-lg-start"
                itemprop="description">
                <h1 class="display-3 ff-t3 text-white animated slideInLeft" itemprop="name">
                  {{ this.$store.state.accueil.titre }} à Grenoble
                </h1>
                <p class="text-white animated ffv slideInLeft my-4 pb-2" itemprop="description">
                  {{ this.$store.state.accueil.texte }} Découvrez nos pizzas
                  artisanales préparées avec des ingrédients frais et de
                  qualité. Livraison rapide et service de qualité.
                </p>
              </div>
              <div class="col-lg-6 text-center text-lg-end overflow-hidden">
                <img class="img-fluid" src="/img/pizzaRounded.webp" alt="Pizza Artisanale à Grenoble"
                  itemprop="image" />
              </div>
            </div>
          </div>
        </div>
        <div class="row g-0 absolute">
          <div class="col-md-6 mx-auto">
            <div class="video position-relative" itemprop="video">
              <video class="rounded" ref="videoPlayer" style="height: 500px; width: 100%; object-fit: cover" autoplay
                muted loop>
                <source :src="'https://www.ncdev0.fr/miavid.mp4'" type="video/mp4" />
              </video>

              <!-- Bouton Play
              <button
                v-if="showPlayButton"
                type="button"
                class="btn-play position-absolute z-100 top-50 start-50 translate-middle"
                @click="playVideo"
              >
                <span> </span>
              </button>
              <button
                v-if="isPlaying"
                type="button"
                class="btn-pause position-absolute z-100"
                @click="pauseVideo"
              >
                <span> </span>
              </button>
              -->
            </div>
          </div>
        </div>
      </div>

      <!-- Service Section -->
      <div id="services" class="container-xxl py-5" itemscope itemtype="http://schema.org/Service">
        <div class="container">
          <div v-if="$store.state.isLoading" class="text-center py-5">
            Chargement des services...
          </div>
          <div v-else-if="$store.state.error" class="alert alert-danger">
            Erreur lors du chargement des services: {{ $store.state.error }}
          </div>
          <div v-else-if="vignettesData && vignettesData.length" class="row g-4">
            <div v-for="(item, index) in vignettesData" :key="index" :class="[
              'col-lg-3',
              'col-md-6',
              'wow',
              'animate__animated',
              'animate__fadeInUp',
            ]" :data-wow-delay="'0.' + (index % 4) + 's'" itemprop="itemListElement" itemscope
              itemtype="http://schema.org/Service">
              <div class="service-item rounded pt-3 h-100">
                <div class="p-4">
                  <i :class="'fa fa-3x ' +
                    (item.icone || 'fa-user-tie') +
                    ' text-primary mb-4'
                    " itemprop="image"></i>
                  <h5 itemprop="name">{{ item.titre || "Service" }}</h5>
                  <p itemprop="description">
                    {{ item.texte || "Description du service" }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="row g-4">
            <!-- Contenu statique en fallback si les données API ne sont pas disponibles -->
            <div v-for="(item, index) in 4" :key="index" :class="[
              'col-lg-3',
              'col-md-6',
              'wow',
              'animate__animated',
              'animate__fadeInUp',
            ]" :data-wow-delay="'0.' + (index % 4) + 's'" itemprop="itemListElement" itemscope
              itemtype="http://schema.org/Service">
              <div class="service-item rounded pt-3">
                <div class="p-4">
                  <i class="fa fa-3x fa-user-tie text-primary mb-4" itemprop="image"></i>
                  <h5 itemprop="name">Service {{ index + 1 }}</h5>
                  <p itemprop="description">
                    Description du service {{ index + 1 }}.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- About Section -->
      <div id="about" class="container-xxl py-5 rounded" style="background-color: rgba(255, 255, 255, 0.9)" itemscope
        itemtype="http://schema.org/AboutPage">
        <div class="container">
          <div class="row g-5 align-items-center">
            <div class="col-lg-6">
              <div class="row g-3">
                <div class="col-6 text-start">
                  <img class="img-fluid rounded w-100 wow animate__animated animate__zoomIn" data-wow-delay="0.1s" :src="'https://admin.mia-restaurant.fr' +
                    proposData.images[0].url
                    " alt="À propos 1" itemprop="image" />
                </div>
                <div class="col-6 text-start">
                  <img class="img-fluid rounded w-75 wow animate__animated animate__zoomIn" data-wow-delay="0.3s" :src="'https://admin.mia-restaurant.fr' +
                    proposData.images[1].url
                    " style="margin-top: 25%" alt="À propos 2" itemprop="image" />
                </div>
                <div class="col-6 text-end">
                  <img class="img-fluid rounded w-75 wow animate__animated animate__zoomIn" data-wow-delay="0.5s" :src="'https://admin.mia-restaurant.fr' +
                    proposData.images[2].url
                    " alt="À propos 3" itemprop="image" />
                </div>
                <div class="col-6 text-end">
                  <img class="img-fluid rounded w-100 wow animate__animated animate__zoomIn" data-wow-delay="0.7s" :src="'https://admin.mia-restaurant.fr' +
                    proposData.images[3].url
                    " alt="À propos 4" itemprop="image" />
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <h5 class="section-title ff-secondary ff-t1 text-start text-primary fw-normal" itemprop="headline">
                À propos
              </h5>
              <h1 class="mb-4 ff-t3" itemprop="name">
                {{ proposData.titre || "Bienvenue chez Mia" }}
              </h1>
              <p class="mb-4 ffv" itemprop="description">
                {{ proposData.texte.texte1 || texte1Secour }}
              </p>
              <p class="mb-4 ffv">
                {{ proposData.texte.texte2 || texte2Secour }}
              </p>
              <div class="row g-4 mb-4">
                <div class="col-sm-6">
                  <div class="d-flex align-items-center border-start border-5 border-primary px-3">
                    <h1 class="flex-shrink-0 display-5 text-primary mb-0" data-toggle="counter-up">
                      150
                    </h1>
                    <div class="ps-4">
                      <p class="mb-0">Places</p>
                      <h6 class="text-uppercase inline-flex mb-0">
                        Jardin et intérieur
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Menu Section -->
      <div id="menu" class="container-xxl py-5">
        <div class="container">
          <div class="text-center wow animate__animated animate__fadeInUp" data-wow-delay="0.1s">
            <h5 class="section-title ff-t1 text-center text-primary fw-normal">
              Menu
            </h5>
            <h1 class="mb-5 ff-t3">Notre Carte</h1>
          </div>

          <div class="tab-class text-center wow animate__animated animate__fadeInUp" data-wow-delay="0.1s">
            <!-- TABS -->
            <ul class="nav nav-pills ffv d-inline-flex justify-content-center border-bottom mb-5">
              <li v-for="title in collectedData" :key="title.id" class="nav-item">
                <button class="nav-link" :class="{ active: activeMenuId === title.id }" type="button"
                  @click="activeMenuId = title.id">
                  {{ title.nom }}
                </button>
              </li>
            </ul>

            <!-- CONTENT -->
            <div class="tab-content ffv">
              <div v-for="menu in collectedData" :key="menu.id" class="tab-pane fade"
                :class="{ 'show active': activeMenuId === menu.id }">
                <div class="row g-4">
                  <div v-for="item in menu.plats" :key="item.id" class="col-lg-6">
                    <div class="d-flex align-items-center">
                      <img v-if="item.imageUrl" class="flex-shrink-0 img-fluid rounded"
                        :src="'https://admin.mia-restaurant.fr' + item.imageUrl" alt="" style="width: 80px" />
                      <div class="w-100 d-flex flex-column text-start ps-4">
                        <h5 class="d-flex justify-content-between border-bottom pb-2">
                          <span>{{ item.titre }}</span>
                          <span class="text-black">{{ item.prix }}€</span>
                        </h5>
                        <small class="fst-italic">
                          {{ item.description }}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- Avis Google -->
      <div id="contact" class="container-xxl py-5">
        <div class="container">
          <div class="text-center wow animate__animated animate__fadeInUp" data-wow-delay="0.1s">
            <google-review />
          </div>
        </div>
      </div>
      <!-- Fin AVIS GOOGLE -->
      <!-- Contact Section -->
      <div id="contact" class="container-xxl py-5">
        <div class="container">
          <div class="text-center wow animate__animated animate__fadeInUp" data-wow-delay="0.1s">
            <h5 class="section-title ff-secondary text-center text-primary fw-normal ff-t1">
              Contact
            </h5>
            <h1 class="mb-5 ff-t3">Contactez-nous</h1>
          </div>
          <div class="row g-4">
            <div class="col-md-6">
              <div class="wow animate__animated animate__fadeInUp" data-wow-delay="0.1s">
                <p class="mb-4 ffv">
                  Nous serons ravis de répondre à vos questions et de vous aider
                  à organiser votre visite chez Mia.
                </p>
                <p class="mb-2 ffv">
                  <i class="fa fa-map-marker-alt me-3"></i>1 Rue Camille
                  Desmoulins, 38000 Grenoble, France
                </p>
                <p class="mb-2 ffv">
                  <i class="fa fa-phone-alt me-3"></i>04 76 47 37 62
                </p>
                <p class="mb-2 ffv">
                  <i class="fa fa-envelope me-3"></i>contact@mia-restaurant.fr
                </p>
              </div>
            </div>
            <div class="col-md-6">
              <form class="wow animate__animated animate__fadeInUp" data-wow-delay="0.3s"
                @submit.prevent="submitContactForm">
                <div class="row g-3">
                  <!-- Message de succès -->
                  <div v-if="submitSuccess" class="col-12">
                    <div class="alert alert-success">
                      Votre message a été envoyé avec succès ! Nous vous
                      répondrons dans les plus brefs délais.
                    </div>
                  </div>

                  <!-- Message d'erreur -->
                  <div v-if="submitError" class="col-12">
                    <div class="alert alert-danger">
                      {{ submitError }}
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-floating">
                      <input type="text" class="form-control" id="name" placeholder="Votre Nom" v-model="form.name"
                        required />
                      <label for="name">Votre Nom</label>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-floating">
                      <input type="email" class="form-control" id="email" placeholder="Votre Email" v-model="form.email"
                        required />
                      <label for="email">Votre Email</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-floating">
                      <textarea class="form-control" placeholder="Votre Message" id="message" style="height: 100px"
                        v-model="form.message" required></textarea>
                      <label for="message">Votre Message</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <button class="btn btn-primary w-100 py-3 ffv" type="submit" :disabled="isSubmitting">
                      <span v-if="isSubmitting">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Envoi en cours...
                      </span>
                      <span v-else>
                        <img style="width: 18px" src="@/assets/img/avion.png" />
                        Envoyer
                      </span>
                    </button>
                    <a href="tel:0476473762" class="btn btn-success ffv mt-2 w-100 py-3">
                      📞 Appeler
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from "@/components/layout/Header.vue";
import AppFooter from "@/components/layout/Footer.vue";
import axios from "axios";
import GoogleReview from "@/components/sections/GoogleReview.vue";

export default {
  name: "HomeView",
  components: {
    AppHeader,
    AppFooter,
    GoogleReview,
  },
  data() {
    return {
      loading: false,
      activeMenuId: null,
      texte1Secour:
        "Chez Mia, nous croyons que chaque repas doit être une expérience mémorable. Notre restaurant est dédié à offrir une cuisine dequalité, préparée avec des ingrédients frais et de saison.",
      texte2Secour:
        "  Nous proposons une variété de plats, allant des classiques traditionnels aux créations culinaires innovantes.",
      collectedData: this.$store.state.collections,
      accueilData: this.$store.state.accueil,
      contactData: this.$store.state.contact,
      horairesData: this.$store.state.horaires,
      vignettesData: this.$store.state.vignettes.vignettes,
      proposData: this.$store.state.propos,
      // Données du formulaire
      form: {
        name: "",
        email: "",
        message: "",
      },
      // États pour les messages
      isSubmitting: false,
      submitSuccess: false,
      submitError: null,
      showPlayButton: true, // bouton central
      isPlaying: false, // état de lecture
      videoPlayer: null,
    };
  },
  computed: {
    proposTexteParsed() {
      try {
        return JSON.parse(this.proposData?.texte || "{}");
      } catch (e) {
        console.warn("proposData.texte JSON invalide:", this.proposData?.texte);
        return {};
      }
    },
  },

  methods: {
    playVideo() {
      if (this.videoPlayer) {
        this.showPlayButton = false;
        this.isPlaying = true;
        this.videoPlayer.play();
      }
    },
    pauseVideo() {
      if (this.videoPlayer) {
        this.showPlayButton = true;
        this.isPlaying = false;
        this.videoPlayer.pause();
      }
    },
    onPlay() {
      this.showPlayButton = false;
      this.isPlaying = true;
    },
    onPause() {
      this.showPlayButton = true;
      this.isPlaying = false;
    },

    // Méthode pour soumettre le formulaire de contact
    async submitContactForm() {
      // Réinitialiser les états
      this.isSubmitting = true;
      this.submitSuccess = false;
      this.submitError = null;

      try {
        // Remplacer par l'URL de votre endpoint
        await axios.post("https://admin.mia-restaurant.fr/contact", {
          email: this.form.email, // Obligatoire
          name: this.form.name, // Optionnel - non implémenté dans le formulaire
          texte: `${this.form.message}`, // Obligatoire
        });
        // Si la requête réussit
        this.submitSuccess = true;

        // Réinitialiser le formulaire
        this.form = {
          name: "",
          email: "",
          message: "",
        };

        // Masquer le message après 5 secondes
        setTimeout(() => {
          this.submitSuccess = false;
        }, 5000);
      } catch (error) {
        // Si la requête échoue
        this.submitError =
          error.response?.data?.message ||
          error.message ||
          "Une erreur est survenue lors de l'envoi du message.";
        console.error("Erreur:", error);

        // Masquer le message après 5 secondes
        setTimeout(() => {
          this.submitError = null;
        }, 5000);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
  mounted() {
    console.log(this.collectedData);
    this.videoPlayer = this.$refs.videoPlayer; // associe la référence après le montage
    if (this.collectedData.length) {
      this.activeMenuId = this.collectedData[0].id
    }
  },
  watch: {
    collectedData: {
      immediate: true,
      handler(val) {
        if (val?.length && !this.activeMenuId) {
          this.activeMenuId = val[0].id
        }
      }
    }
  }
};
</script>

<style scoped>
.video {
  overflow: hidden;
  border-radius: 10px;
  position: relative;
}

.btn-play {
  width: 80px;
  height: 80px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s;
}

.btn-play:hover {
  background: rgba(0, 0, 0, 0.8);
}

.btn-play span {
  display: block;
  width: 0;
  height: 0;
  border-left: 20px solid white;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  margin-left: 5px;
}

/* Style personnalisé pour les boutons des tabs */
.nav-pills .nav-link {
  background-color: #f8f9fa;
  color: #212529;
  border: none;
  margin-right: 5px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.nav-pills .nav-link.active {
  background-color: #ed2f2d;
  color: white;
}

.nav-pills .nav-link:hover {
  background-color: #d62927;
  color: white;
}
</style>
